/**
 * Fuzzy Search Module - Сверхбыстрый нечёткий поиск (uFuzzy)
 */

(function(window) {
    'use strict';

    const FuzzySearch = {};
    let filesListFuzzy = [];
    let uf = null;

    function getUF() {
        if (!uf && window.uFuzzy) {
            uf = new window.uFuzzy({
                intraMode: 1, 
                intraIns: 1,
                intraSub: 1,
                intraTrn: 1,
                intraDel: 1
            });
        }
        return uf;
    }

    FuzzySearch.uFuzzyListGet = function() {
        const __files = (window.filesStore && typeof window.filesStore.getFiles==='function') ? window.filesStore.getFiles() : [];
        if (filesListFuzzy.length === 0 && __files && __files.length) {
            filesListFuzzy = __files.map(i => FuzzySearch.fuzzyListCleanItem(i.n || i.name || ''));
        }
        return filesListFuzzy;
    };

    FuzzySearch.fuzzyListCleanItem = function(inp) {
        if (!inp) return '';
        return inp.toLowerCase()
            .replace(/(?:(\s+rus|@Hauri|@CoS)?\.\w{2,4}$)/gi, '')
            .replace(/[^a-zа-я0-9\s]/gi, ' ')
            .replace(/\s+/g, ' ')
            .trim();
    };

    FuzzySearch.resetCache = function() {
        filesListFuzzy = [];
    };

    FuzzySearch.search = function(query) {
        const u = getUF();
        if (!u) return [];

        const haystack = FuzzySearch.uFuzzyListGet();
        const needle = query.toLowerCase().trim();
        if (!needle) return [];

        let idxs = u.filter(haystack, needle);
        if (!idxs || idxs.length === 0) return [];

        const allFiles = window.filesStore.getFiles();
        return idxs.map(i => ({
            item: allFiles[i],
            score: 0
        }));
    };

    /**
     * Rank items using uFuzzy. 
     * IMPORTANT: This method now returns ALL input items, ensuring no results are lost.
     * Items that match the fuzzy pattern are moved to the top and sorted by relevance.
     */
    FuzzySearch.rankItems = function(query, items, options = {}) {
        const debugMode = typeof window !== 'undefined' && window.location && window.location.search.includes('debug=1') ? '1' : '0';
        const u = getUF();
        const needle = query.toLowerCase().trim();
        
        // Basic safety checks
        if (!u || !needle || !items || items.length === 0) {
            if (debugMode === '1') console.log('[uFuzzy] rankItems skipped:', { reason: !u ? 'uFuzzy not available' : !needle ? 'empty query' : 'no items', query, itemsCount: items?.length || 0 });
            return (items || []).map(item => ({ item, score: 0 }));
        }

        const keys = options.keys || ['name', 'n', 'sn'];
        const cleanItems = items.map(it => {
            if (typeof it === 'string') return FuzzySearch.fuzzyListCleanItem(it);
            let text = '';
            for (let k of keys) { if (it[k]) text += ' ' + it[k]; }
            return FuzzySearch.fuzzyListCleanItem(text);
        });

        if (debugMode === '1') {
            console.log('[uFuzzy] rankItems called:', { query, itemsCount: items.length, keys, sampleCleanItems: cleanItems.slice(0, 3) });
        }

        try {
            // 1. Filter to get matching indices
            let idxs = u.filter(cleanItems, needle);
            
            if (debugMode === '1') {
                console.log('[uFuzzy] filter result:', { matchedIndices: idxs?.length || 0, totalItems: cleanItems.length, sampleMatches: idxs?.slice(0, 5).map(i => ({ idx: i, text: cleanItems[i], original: items[i]?.n || items[i]?.name || items[i] })) });
            }
            
            // If no fuzzy matches, return all items as is (with 0 score)
            if (!idxs || idxs.length === 0) {
                if (debugMode === '1') console.log('[uFuzzy] No matches found, returning all items with score 0');
                return items.map(item => ({ item, score: 0 }));
            }

            // 2. Get Info (for sorting matches)
            let info = u.info(idxs, cleanItems, needle);
            
            if (debugMode === '1') {
                console.log('[uFuzzy] info result:', { 
                    infoKeys: Object.keys(info),
                    ranges: info.ranges?.slice(0, 5),
                    chars: info.chars?.slice(0, 5),
                    terms: info.terms?.slice(0, 5),
                    sampleInfo: idxs.slice(0, 5).map((idx, i) => ({
                        idx,
                        text: cleanItems[idx],
                        chars: info.chars?.[i],
                        terms: info.terms?.[i],
                        original: items[idx]?.n || items[idx]?.name || items[idx]
                    }))
                });
            }
            
            // 3. Sort matches - returns order indices (best match first)
            let order = u.sort(info, cleanItems, needle);

            if (debugMode === '1') {
                console.log('[uFuzzy] sort result (order):', { 
                    order: order.slice(0, 10),
                    sortedItems: order.slice(0, 10).map((orderIdx, rank) => {
                        const matchIdx = idxs[orderIdx];
                        return {
                            rank: rank + 1,
                            orderIdx,
                            matchIdx,
                            text: cleanItems[matchIdx],
                            chars: info.chars?.[orderIdx],
                            terms: info.terms?.[orderIdx],
                            original: items[matchIdx]?.n || items[matchIdx]?.name || items[matchIdx],
                            fullPath: items[matchIdx]?.fullPath || items[matchIdx]?.p || ''
                        };
                    })
                });
            }

            // 4. Map back matched items in order
            // Score is based on position: first item gets highest score (1000), decreasing by 1 for each position
            // This ensures uFuzzy-sorted items are ranked higher than non-matching items (score 0)
            const maxScore = 1000;
            const matchedItems = order.map((orderIdx, rank) => {
                const matchIdx = idxs[orderIdx];
                // Higher rank (earlier position) = higher score
                const fuzzyScore = maxScore - rank;
                return {
                    item: items[matchIdx],
                    score: fuzzyScore
                };
            });

            // 5. CONCEPTUAL FIX: Append all other items that didn't match fuzzy pattern
            // This ensures fuzzy search only reorders, never removes.
            const matchedIndicesSet = new Set(idxs);
            const unmatchedItems = items
                .map((item, originalIdx) => ({ item, originalIdx }))
                .filter(obj => !matchedIndicesSet.has(obj.originalIdx))
                .map(obj => ({ item: obj.item, score: 0 }));

            const result = [...matchedItems, ...unmatchedItems];
            
            if (debugMode === '1') {
                console.log('[uFuzzy] Final ranked result:', {
                    matchedCount: matchedItems.length,
                    unmatchedCount: unmatchedItems.length,
                    totalCount: result.length,
                    top10: result.slice(0, 10).map((r, idx) => ({
                        position: idx + 1,
                        name: r.item?.n || r.item?.name || r.item,
                        score: r.score,
                        fullPath: r.item?.fullPath || r.item?.p || '',
                        has531211: (r.item?.n || r.item?.name || '').includes('531211')
                    }))
                });
            }

            return result;
        } catch (e) {
            console.error('[FuzzySearch.rankItems] uFuzzy error:', e);
            // Fallback to all items in original order
            return items.map(item => ({ item, score: 0 }));
        }
    };

    /**
     * Rank items using Fuse.js.
     * Supports date-like pattern normalization (e.g., "53.12.11" -> "531211").
     * Returns ALL input items, ensuring no results are lost.
     * Items that match the fuzzy pattern are moved to the top and sorted by relevance.
     */
    FuzzySearch.rankItemsFuse = function(query, items, options = {}) {
        const debugMode = typeof window !== 'undefined' && window.location && window.location.search.includes('debug=1') ? '1' : '0';
        
        // Basic safety checks
        if (!window.Fuse || !query || !items || items.length === 0) {
            if (debugMode === '1') console.log('[Fuse.js] rankItemsFuse skipped:', { reason: !window.Fuse ? 'Fuse.js not available' : !query ? 'empty query' : 'no items', query, itemsCount: items?.length || 0 });
            return (items || []).map(item => ({ item, score: 0 }));
        }

        const keys = options.keys || ['fullPath', 'name', 'path', 'n', 'p'];
        const threshold = options.threshold !== undefined ? options.threshold : 0.3;
        
        // Normalize query: remove separators for date-like patterns (e.g., "53.12.11" -> "531211")
        const normalizedQuery = String(query).replace(/[\.\-\/\s]/g, '');
        const originalQuery = String(query).trim();
        
        // Helper function to normalize string (remove separators)
        const normalizeString = (str) => {
            if (typeof str !== 'string') return str || '';
            return str.replace(/[\.\-\/\s]/g, '');
        };
        
        // Create normalized versions of items for search (preserve originals)
        // Add normalized fields with _norm_ prefix for Fuse.js search
        const itemsWithNormalized = items.map((item, idx) => {
            const normalizedItem = { ...item, _originalIndex: idx };
            for (const key of keys) {
                const value = item[key];
                if (value !== undefined && value !== null) {
                    normalizedItem[`_norm_${key}`] = normalizeString(String(value));
                }
            }
            return normalizedItem;
        });

        // Configure Fuse.js options - search in normalized fields
        // Веса: по умолчанию имя файла важнее пути
        const defaultWeights = {
            'n': 0.5,
            'name': 0.5,
            'fullPath': 0.2,
            'path': 0.15,
            'p': 0.15
        };
        
        const fuseOptions = {
            keys: keys.map(key => ({
                name: `_norm_${key}`,
                weight: options.weights && options.weights[key] !== undefined 
                    ? options.weights[key] 
                    : (defaultWeights[key] !== undefined ? defaultWeights[key] : 1.0)
            })),
            includeScore: true,
            includeMatches: options.includeMatches !== undefined ? options.includeMatches : false, // Включить matches для подсветки
            threshold: threshold,
            ignoreLocation: true,
            minMatchCharLength: 1
        };

        if (debugMode === '1') {
            console.log('[Fuse.js] rankItemsFuse called:', { 
                query: originalQuery, 
                normalizedQuery, 
                itemsCount: items.length, 
                keys, 
                threshold,
                sampleItems: items.slice(0, 3).map(item => ({
                    name: item.n || item.name,
                    fullPath: item.fullPath || item.p || '',
                    normalizedName: normalizeString(item.n || item.name || ''),
                    normalizedFullPath: normalizeString(item.fullPath || item.p || '')
                }))
            });
        }

        try {
            // Create Fuse instance with normalized items
            const fuse = new window.Fuse(itemsWithNormalized, fuseOptions);
            
            // Search with normalized query (for date-like patterns)
            const results = fuse.search(normalizedQuery);
            
            if (debugMode === '1') {
                console.log('[Fuse.js] search result:', { 
                    matchedCount: results.length, 
                    totalItems: items.length,
                    sampleMatches: results.slice(0, 5).map(r => ({
                        name: r.item?.n || r.item?.name,
                        fullPath: r.item?.fullPath || r.item?.p || '',
                        score: r.score,
                        refIndex: r.refIndex
                    }))
                });
            }
            
            // If no matches, return all items with score 0
            if (!results || results.length === 0) {
                if (debugMode === '1') console.log('[Fuse.js] No matches found, returning all items with score 0');
                return items.map(item => ({ item, score: 0 }));
            }

            // Convert Fuse.js results to our format
            // Fuse.js score: 0 = perfect match, 1 = no match
            // We invert it: higher score = better match
            const maxScore = 1000;
            const matchedItems = results.map((result, rank) => {
                // Get original item (without normalized fields)
                const originalItem = items[result.item._originalIndex];
                
                // Convert Fuse.js score (0-1) to our score (1000-0)
                // Lower Fuse.js score = better match = higher our score
                const fuseScore = result.score || 1.0;
                const invertedScore = maxScore - (fuseScore * maxScore);
                // Add small bonus for earlier position
                const positionBonus = maxScore - rank;
                // Combine: prioritize Fuse.js score, then position
                const finalScore = Math.max(invertedScore, positionBonus);
                
                // Include matches data if available (for highlighting)
                const resultData = {
                    item: originalItem,
                    score: finalScore
                };
                
                if (options.includeMatches && result.matches) {
                    resultData.matches = result.matches;
                    if (debugMode === '1' && rank < 3) {
                        console.log('[Fuse.js] rankItemsFuse - matches saved:', {
                            itemName: originalItem.n || originalItem.name,
                            matchesCount: result.matches.length,
                            matchesKeys: result.matches.map(m => m.key)
                        });
                    }
                }
                
                return resultData;
            });

            // Append unmatched items (with score 0)
            const matchedIndicesSet = new Set(results.map(r => r.item._originalIndex));
            const unmatchedItems = items
                .map((item, originalIdx) => ({ item, originalIdx }))
                .filter(obj => !matchedIndicesSet.has(obj.originalIdx))
                .map(obj => ({ item: obj.item, score: 0 }));

            const result = [...matchedItems, ...unmatchedItems];
            
            if (debugMode === '1') {
                console.log('[Fuse.js] Final ranked result:', {
                    matchedCount: matchedItems.length,
                    unmatchedCount: unmatchedItems.length,
                    totalCount: result.length,
                    top10: result.slice(0, 10).map((r, idx) => ({
                        position: idx + 1,
                        name: r.item?.n || r.item?.name || r.item,
                        score: r.score,
                        fullPath: r.item?.fullPath || r.item?.p || '',
                        has531211: (r.item?.n || r.item?.name || '').includes('531211')
                    }))
                });
            }

            return result;
        } catch (e) {
            console.error('[FuzzySearch.rankItemsFuse] Fuse.js error:', e);
            // Fallback to all items in original order
            return items.map(item => ({ item, score: 0 }));
        }
    };

    /**
     * Sort items by relevance using Fuse.js.
     * Returns the items in the new order, preserving the original set size.
     */
    FuzzySearch.sortByRelevanceFuse = function(query, items, options = {}) {
        const ranked = FuzzySearch.rankItemsFuse(query, items, options);
        return ranked.map(r => r.item);
    };

    /**
     * Sort items by relevance.
     * Returns the items in the new order, preserving the original set size.
     */
    FuzzySearch.sortByRelevance = function(query, items, options = {}) {
        const ranked = FuzzySearch.rankItems(query, items, options);
        return ranked.map(r => r.item);
    };

    window.FuzzySearch = FuzzySearch;
    window.uFuzzyListGet = FuzzySearch.uFuzzyListGet;
    window.fuzzySortByRelevance = FuzzySearch.sortByRelevance;
    window.fuzzyRankItems = FuzzySearch.rankItems;
    window.fuzzyRankItemsFuse = FuzzySearch.rankItemsFuse;
    window.fuzzySortByRelevanceFuse = FuzzySearch.sortByRelevanceFuse;

})(window);

export const fuzzySearch = window.FuzzySearch;
